var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("modal", {
        ref: "centerModal",
        attrs: { "sheet-class": "ct-sheet ct-lookup" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c("h4", [
                  _c("i", { staticClass: "fa fa-building-o" }),
                  _vm._v(" ข้อมูลลูกค้า (AP)"),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("div", { staticClass: "modal-search-bar" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12" },
                      [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [
                            _c("i", {
                              staticClass: "fa fa-search",
                              staticStyle: { "margin-right": "4px" },
                            }),
                            _vm._v(_vm._s(_vm.ui.search || "Search")),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.retrieveSearch["search_text"],
                                  expression: "retrieveSearch['search_text']",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control input-sm",
                              attrs: { type: "text" },
                              domProps: {
                                value: _vm.retrieveSearch["search_text"],
                              },
                              on: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.loadData.apply(null, arguments)
                                },
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.retrieveSearch,
                                    "search_text",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "input-group-btn" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "btn btn-sm bg-navy",
                                  on: { click: _vm.loadData },
                                },
                                [_c("i", { staticClass: "fa fa-search" })]
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "view-toolbar" }, [
                  _c("div", { staticClass: "view-toggle" }, [
                    _c(
                      "button",
                      {
                        staticClass: "view-btn",
                        class: { "view-btn--active": _vm.viewMode === "table" },
                        attrs: { type: "button", title: "Table View" },
                        on: {
                          click: function ($event) {
                            _vm.viewMode = "table"
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fas fa-th-list" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.ui.erp_table || "Table")),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "view-btn",
                        class: { "view-btn--active": _vm.viewMode === "card" },
                        attrs: { type: "button", title: "Card View" },
                        on: {
                          click: function ($event) {
                            _vm.viewMode = "card"
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fas fa-th-large" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Card")]),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.viewMode === "table",
                        expression: "viewMode === 'table'",
                      },
                    ],
                    staticClass: "row",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("ag-table", {
                          ref: "agr",
                          attrs: { footer: false },
                          on: {
                            ready: function ($event) {
                              return _vm.initTable()
                            },
                            "cell-clicked": function ($event) {
                              return _vm.sendData($event.data)
                            },
                            "on-sort-changed": function ($event) {
                              return _vm.onGridSortChanged($event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.viewMode === "card",
                        expression: "viewMode === 'card'",
                      },
                    ],
                    staticClass: "card-grid",
                  },
                  [
                    _vm._l(_vm.displayData, function (x) {
                      return _c(
                        "div",
                        {
                          key: x.customer_code,
                          staticClass: "item-card",
                          on: {
                            click: function ($event) {
                              return _vm.sendData(x)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "item-card-avatar" }, [
                            _c("i", { staticClass: "fas fa-building" }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "item-card-body" }, [
                            _c("div", { staticClass: "item-card-top" }, [
                              _c("span", { staticClass: "item-card-code" }, [
                                _vm._v(_vm._s(x.customer_code)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "item-card-sub",
                                attrs: { title: x.name_th },
                              },
                              [_vm._v(_vm._s(x.name_th))]
                            ),
                          ]),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    !_vm.displayData || _vm.displayData.length === 0
                      ? _c("div", { staticClass: "card-empty" }, [
                          _c("i", { staticClass: "fas fa-inbox" }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.ui.erp_data_not_found || "ไม่พบข้อมูล")
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("loading-box", { ref: "myLB" }),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "pull-left" },
                  [
                    _c("pagination", {
                      ref: "paging",
                      on: {
                        "page-change": function ($event) {
                          return _vm.pageChange($event.page)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm modal-close-btn",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.closeModal()
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-times" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.ui.csm_v2_close_window || "ปิดหน้าต่าง") +
                        "\n      "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }